import React from 'react';

function AnimationAboutHeaderSplit({children, id}) {
    return (
        <div className="AnimationAboutHeaderSplit" id={id}>
            {children}
        </div>
    );
}

export default AnimationAboutHeaderSplit;
